import axios from 'axios';

// Resolves the API base (including /v1). An explicit REACT_APP_API_BASE_URL
// (CRA exposes only REACT_APP_* vars) wins; otherwise the brand is picked from
// the hostname. Trailing slashes are trimmed so paths join cleanly.
const getApiBase = () => {
  const envBase = process.env.REACT_APP_API_BASE_URL;
  if (envBase) return `${envBase.replace(/\/+$/, '')}/v1`;
  const { hostname } = window.location;
  if (hostname.includes('altel')) return 'https://survey.altel.kz/v1';
  return 'https://survey.tele2.kz/v1';
};

export const getQuestions = (token) => {
  return axios.get(`${getApiBase()}/survey/subscriber/${token}`);
};

export const submitAnswers = (token, form) => {
  return axios({
    method: "post",
    url: `${getApiBase()}/survey/subscriber/${token}/form`,
    data: form,
    headers: {},
  });
};